import React from "react";

function Loder() {
  return (
    <div className="loader_classs">
      <div className="triple-spinner"></div>
    </div>
  );
}

export default Loder;
